/**
 * Categorical concerns accepted by POST /portal-helpline/start `concerns`.
 * Mirrors the BE concern_type pgEnum exactly — order preserved so any
 * iteration order matches BE for analytics consistency.
 */
export const CONCERN_VALUES = [
  'anxiety_worry',
  'academic_stress',
  'relationship_issues',
  'depression',
  'family_conflict',
  'self_esteem',
  'sleep_disturbance',
  'substance_concerns',
  'grief_loss',
  'bipolar_disorder',
  'enquiry',
  'wellness_followup',
  'others',
] as const;

export type Concern = (typeof CONCERN_VALUES)[number];

export function isConcern(value: unknown): value is Concern {
  return typeof value === 'string' && (CONCERN_VALUES as readonly string[]).includes(value);
}

/** i18n key under the `clientPortalHelpline` namespace for a concern label. */
export function concernI18nKey(concern: Concern): `concerns.${Concern}` {
  return `concerns.${concern}`;
}
